import { hasOpenRaiseRight } from './betting';
export const legalActions = (state) => {
    if (state.phase !== 'acting' || state.toAct === null)
        return [];
    const player = state.players.find((p) => p.seat === state.toAct);
    if (!player || player.folded || player.allIn)
        return [];
    const toCall = state.currentBet - player.committedThisStreet;
    const shoveAmount = player.committedThisStreet + player.stack;
    const legal = [];
    if (player.stack <= 0)
        return legal; // already covered by allIn guard above, but stay defensive
    if (toCall > 0) {
        legal.push({ kind: 'fold' });
        legal.push({ kind: 'call', min: Math.min(state.currentBet, shoveAmount), max: Math.min(state.currentBet, shoveAmount) });
        // A player with raise rights can always raise, even short of a full min-raise - a shove for
        // less than a full raise is still a legal raise in NLHE, it just won't reopen action for
        // players who already acted (that's `hasOpenRaiseRight`'s job, not this gate's). Capping `min`
        // at shoveAmount when the full min-raise is unreachable makes it a forced-amount all-in raise.
        if (hasOpenRaiseRight(state, state.toAct) && shoveAmount > state.currentBet) {
            legal.push({ kind: 'raise', min: Math.min(state.minRaiseTo, shoveAmount), max: shoveAmount });
        }
    }
    else {
        legal.push({ kind: 'check' });
        const minBet = state.spec.stakes.bb;
        // Same logic as the raise branch: a shove below the table's min-bet is still a legal bet.
        if (shoveAmount > 0) {
            legal.push({ kind: 'bet', min: Math.min(minBet, shoveAmount), max: shoveAmount });
        }
    }
    // 'jam' is a raise/bet sized to exactly the shove amount, offered as a one-click "all in" affordance
    // so the caller needn't compute the amount. But jam IS a raise/bet, so it is legal ONLY when hero
    // could legally bet or raise - mirroring the gates above: the not-facing branch (a shove is a bet),
    // or the facing branch ONLY when hero holds an open-raise right AND the shove tops the current bet.
    // Facing a bet with no raise right (e.g. after a villain's sub-min all-in that did not reopen action)
    // a jam would be an ILLEGAL re-raise, so it must NOT be offered - same rule as the `raise` push.
    const canBetOrRaise = toCall > 0
        ? hasOpenRaiseRight(state, state.toAct) && shoveAmount > state.currentBet
        : shoveAmount > 0;
    if (canBetOrRaise) {
        legal.push({ kind: 'jam', min: shoveAmount, max: shoveAmount });
    }
    return legal;
};
//# sourceMappingURL=legal.js.map